import { useQuery } from "react-query";
import { useAccessToken } from "hooks/useAccessToken";
import { QUERY_STALE_TIME } from "utils/constants";
import queryFnEnergyConsumptionCard from "ApiLayer/Reports/Baseline/queryCurrentAnnualEnergyConsumptionCard";

export const useCurrentAnnualEnergyConsumptionCard = (filtersetUid: string) => {
    const accessToken = useAccessToken();

    return useQuery({
        queryKey: ["currentAnnualEnergyConsumptionCard", filtersetUid],
        queryFn: async () =>
            queryFnEnergyConsumptionCard(accessToken, {
                reportFiltersetUid: filtersetUid,
            }),
        staleTime: QUERY_STALE_TIME,
    });
};
